import PropTypes from 'prop-types';
import React from 'react';
import { Chip, withStyles } from '@material-ui/core';

const selectableChipStyles = {
  root: {
    '& span': {
      whiteSpace: 'initial',
      padding: '8px',
    },
  },
};

const SelectableChip = ({ selected, ...other }) => (
  <div
    style={{
      display: 'inline-block',
      backgroundColor: '#fff',
      marginRight: 8,
      marginBottom: 8,
      borderRadius: 16,
      overflow: 'hidden',
    }}
  >
    <Chip color={selected ? 'primary' : 'default'} variant="outlined" {...other} />
  </div>
);
SelectableChip.propTypes = {
  selected: PropTypes.bool,
};

export default withStyles(selectableChipStyles)(SelectableChip);
